import React from 'react';
import { RadioButtonLayoutProps } from 'ui-builder';
import { cn } from 'shadcn-ui';
import ErrorsWrapper from './ErrorsWrapper';

function ShadcnRadioButtonLayout(props: RadioButtonLayoutProps) {
  return (
    <ErrorsWrapper name={`${props.name}-${props.groupValue}`} errors={props.errors}>
      <label
        htmlFor={`${props.name}-${props.groupValue}`}
        className={cn(
          'inline-flex items-center gap-2 cursor-pointer select-none text-sm text-foreground',
          props.isDisabled && 'cursor-default opacity-50',
        )}
        title={props.title}
      >
        <span
          className={cn(
            'size-4 shrink-0 rounded-full border border-input shadow-xs transition-shadow flex items-center justify-center',
            'focus-within:border-ring focus-within:ring-[3px] focus-within:ring-ring/50',
            props.value && 'border-primary bg-primary',
          )}
        >
          <input
            value={props.groupValue || ''}
            type="radio"
            className="sr-only"
            id={`${props.name}-${props.groupValue}`}
            checked={props.value || false}
            onChange={props.onChangeCallback}
            name={`${props.name}-${props.groupValue}`}
            disabled={props.isDisabled}
          />
          {props.value && (
            <span className="size-2 rounded-full bg-primary-foreground" />
          )}
        </span>
        {!props.hideLabel && props.label}
      </label>
      {props.hint && (
        <span className="text-xs text-muted-foreground italic mt-1 block ml-6">
          {props.hint}
        </span>
      )}
    </ErrorsWrapper>
  );
}

export default ShadcnRadioButtonLayout;
